export function fLowerCase(string) {
  return string.toLowerCase();
}

export function fToCurrency(amount) {
  return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export function fToTitle(string) {
  return string
    ?.replace(/([A-Z])/g, ' $1')
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
}

export function fToTitleMultipleWords(string) {
  return string?.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

export function fNoNegativeOrLetters(e) {
  if (e.key === '-' || e.key === 'e' || e.key === 'E') {
    e.preventDefault();
  }
}

export function addHyperlink(text) {
  if (!text) return text;
  const markdownLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s]+?)\)/g;
  const plainUrlRegex = /\bhttps?:(\\\\|\/\/)[^\s<>"']+/gi;

  const elements = [];
  let lastIndex = 0;
  let match;

  // eslint-disable-next-line no-cond-assign
  while ((match = markdownLinkRegex.exec(text)) !== null) {
    const [full, label, url] = match;
    const { index } = match;

    if (lastIndex < index) elements.push(text.slice(lastIndex, index));

    elements.push(
      <a
        key={index}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          whiteSpace: 'pre-wrap',
          color: '#1976d2',
          textDecoration: 'underline',
        }}
      >
        {label}
      </a>
    );

    lastIndex = index + full.length;
  }

  const remainder = text.slice(lastIndex);
  const result = [];

  let lastPlainIndex = 0;
  const matches = [...remainder.matchAll(plainUrlRegex)];
  if (!matches.length) {
    result.push(remainder);
  } else {
    matches.forEach((match, i) => {
      const { index } = match;
      const url = match[0];
      if (lastPlainIndex < index) result.push(remainder.slice(lastPlainIndex, index));
      result.push(
        <a
          key={`url-${i}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap',
            color: '#1976d2',
            textDecoration: 'underline',
          }}
        >
          {url}
        </a>
      );
      lastPlainIndex = index + url.length;
    });

    if (lastPlainIndex < remainder.length) result.push(remainder.slice(lastPlainIndex));
  }

  return [...elements, ...result];
}

export function trimData(data) {
  return JSON.parse(
    JSON.stringify(data, (key, value) => {
      if (typeof value !== 'string') return value;

      const trimmed = value.trim();
      return trimmed === '' ? null : trimmed;
    })
  );
}
